import { render, staticRenderFns } from "./frontdeskcards.vue?vue&type=template&id=78e6c1be&scoped=true&"
import script from "./frontdeskcards.vue?vue&type=script&lang=js&"
export * from "./frontdeskcards.vue?vue&type=script&lang=js&"
import style0 from "./frontdeskcards.vue?vue&type=style&index=0&id=78e6c1be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e6c1be",
  null
  
)

export default component.exports